export const WalletFormType = Object.freeze({
  REGISTER: 'REGISTER',
  LOGIN: 'LOGIN',
  PASSWORD_RECOVERY: 'PASSWORD_RECOVERY',
  PASSWORD_RESET: 'PASSWORD_RESET'
})
